module.exports = __webpack_public_path__ + "static/media/encaje_piezas_cortina.2b208d3c.jpg";